var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJapan2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Japan@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-239.000000, -1050.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Japan"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.000000, 980.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_7_copy-16",
    fill: "#FFFFFF",
    x: 0.52,
    y: 0.53,
    width: 70,
    height: 47,
    rx: 6.36
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3_copy_2-2",
    fill: "#ED5565",
    cx: 35.52,
    cy: 24.03,
    r: 9.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan2X);
export default __webpack_public_path__ + "static/media/Japan@2x.0d3bd45912674955fb19d49ac7067a99.svg";
export { ForwardRef as ReactComponent };